import clsx from 'clsx';

interface StarProps {
    className?: string;
}

export default function Star({ className }: StarProps) {
    return (
        <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={clsx('fill-product-500', className)}
        >
            <path d="M11.5355 3.10102C12.0611 -0.285516 16.9389 -0.285523 17.4645 3.10101L18.2612 8.23437C18.4616 9.52547 19.4745 10.5384 20.7656 10.7388L25.899 11.5355C29.2855 12.0611 29.2855 16.9389 25.899 17.4645L20.7656 18.2612C19.4745 18.4616 18.4616 19.4745 18.2612 20.7656L17.4645 25.899C16.9389 29.2855 12.0611 29.2855 11.5355 25.899L10.7388 20.7656C10.5384 19.4745 9.52547 18.4616 8.23437 18.2612L3.10102 17.4645C-0.285516 16.9389 -0.285523 12.0611 3.10101 11.5355L8.23437 10.7388C9.52547 10.5384 10.5384 9.52547 10.7388 8.23437L11.5355 3.10102Z" />
        </svg>
    );
}
